import { ContainerType } from '../common/Constant';
import log from 'loglevel';
// import Compat from './compat/Compat';
import DBCompatController from './compat/DBCompatController';
import DBController from './DBController';
import { cueData } from './mock';
import CompatBoardSeek from './strategy/CompatBoardSeek';
import CompatQueryNormal from './strategy/CompatQueryNormal';
import CompatQuerySeek from './strategy/CompatQuerySeek';
import QueryBoardSeek from './strategy/QueryBoardSeek';
import QueryContext from './strategy/QueryContext';
import QueryNormal from './strategy/QueryNormal';
import QuerySeek from './strategy/QuerySeek';
import ActivatedMaker from './utils/ActivatedMaker';
import CIDMaker from './utils/CIDMaker';
import WatchStatusMaker from './utils/WatchStatusMaker';

const VHALL_DOC_VOD_STORE = 'SHY';
/** 查询时间跨度 */
const QUERY_INTERVAL = 300 / 1000;
/** seek阈值，超过此阈值。则走seek逻辑，否则走正常normal逻辑 */
const SEEK_THRESHOLD = 1.0;
/**
 * 点播模块
 *
 * @export
 * @class Vod
 */
export default class Vod {
  constructor() {
    this.CLASS_NAME = this.constructor.name;
    this._data = null;
    this._store = null;
    this._time = 0;
    this._allCid = [];
    this._allWatchStatus = [];
    this._allActivatedCids = [];

    this._controller = null;
    this.strategy = null;
    // 是否使用降级策略
    this.useCompat = true;
    // this.useCompat = Compat.isSupported() === false;

    if (this.useCompat) {
      // 降级策略, 使用自己定义的数据结构
      this._controller = new DBCompatController();
      this.strategy = {
        normal: new CompatQueryNormal(),
        seek: new CompatQuerySeek(),
        boardSeek: new CompatBoardSeek()
      };
    } else {
      // 支持indexedDB, 使用数据库查询方式
      this._controller = new DBController();
      this._controller.init(Vod.defaultDBOption);

      // 创建查询策略集合
      this.strategy = {
        normal: new QueryNormal(),
        seek: new QuerySeek(),
        boardSeek: new QueryBoardSeek()
      };
    }

    this.context = new QueryContext(this.dbController);

    // 计时变量，用来统计因安装数据错过多久。 安装完成后的那次设置vodTime, 将把错失的这段数据进行回补
    this._lostTime = 0;

    // 上次查询的开始时间， 如果本次查询时间大于上次查询的开始时间加QUERY_INTERVAL秒，则把上次查询加QUERY_INTERVAL秒时间定义为本次的开始时间
    this._lastQueryTime = 0;

    this.type = '';
    this.cid = '';
  }

  destroy() {
    // dbController 被策略和上下文引用，先重置策略和上下文，再清理dbController，以防引用未被及时清理造成泄漏
    this.strategy = null;

    this.context.destroy();
    this.context = null;

    if (this.dbController) {
      this.dbController.destroy();
      this._controller = null;
    }

    this._allCid = [];
    this._allActivatedCids = [];
    this._allWatchStatus = [];

    this._lostTime = 0;
  }

  async mock() {
    this.data = cueData.cuepoint;
  }

  /**
   * 输入时间查询数据，此处执行2种策略
   * 1，当时间按照一定步长进行递增的时候，执行普通查询策略
   * 2，当时间超过一定时间跨度（SEEK_THRESHOLD）后，执行seek策略
   *
   * @param {*} t 时间，基于播放时间。秒为单位
   * @returns 返回查询到的时间点对应的数据，可以不实用该返回值，在查询数据的时候，进行了事件派发
   * @memberof Vod
   */
  async time(t) {
    log.debug('Vod async time');
    if (!window.dataInstallComplete) {
      this._lostTime = t;
      return [];
    }

    // 查询的起始和终止时间
    let queryTime = t;

    /**
     * 1. 如果是第一次获取时间查询数据，则从头获取（播放器第一次从头播放时传入的时间点非0）。
     * 2. 否则如果当前时间减上次查询开始时间大于阈值，证明timeupdate 间隔过长，于是将起始时间定义为上一次的结束时间
     */
    if (this._lastQueryTime === 0) {
      queryTime = -0.1;
    } else if (queryTime - this._lastQueryTime >= QUERY_INTERVAL) {
      queryTime = this._lastQueryTime + QUERY_INTERVAL;
    }

    let queryTimeEnd = t + QUERY_INTERVAL;

    // 是否因为数据未安装导致错失数据，如果有错失数据，将从头补一下
    if (this._lostTime !== 0) {
      queryTime = -0.1;
      this._lostTime = 0;
    }

    const elapsed = Math.abs(this._time - t);
    let strategy = null;
    if (elapsed > SEEK_THRESHOLD || this._lastQueryTime === 0) {
      strategy = this.type === ContainerType.DOCUMENT ? this.strategy.seek : this.strategy.boardSeek;
      // 如果是seek模式，需要先清理一下画面
      log.info(`seek 模式, queryTime: ${queryTime}, queryTimeEnd: ${queryTimeEnd}`);
      this._ee.dispatch('clearDoodle');
    } else {
      strategy = this.strategy.normal;
    }
    this._time = t;
    // 外部控制使用什么策略
    this.context.strategy = strategy;
    this.context.cid = this.cid;

    let result = await this.context.execute(queryTime, queryTimeEnd);

    let data = [];
    // 将查询结果进行一次整理，外发
    if (result.length > 0) {
      result.forEach(item => data.push(item.content));
      // log.info(`外发回放查询结果 ${data}`);
      this._ee.dispatch('vod_event', data);
    }

    this._lastQueryTime = t;
    // 输出日志信息
    this._outputQueryResult(result, t, queryTime, queryTimeEnd);
    return data;
  }

  set store(val) {
    this._store = val;
    this._ee = this.store.getKV('ee');
  }

  get store() {
    return this._store;
  }

  set data(data) {
    let cidMaker = new CIDMaker();
    this._data = data;
    this._allCid = cidMaker.make(this._data);
    this._allActivatedCids = new ActivatedMaker(cidMaker).make(this._data);
    this._allWatchStatus = new WatchStatusMaker(cidMaker).make(this._data);
    this.dbController.install(data);
  }

  /**
   * cid: 容器id
   * create: 创建于基于播放时间的时间点，对应time属性
   * destroy: 销毁于基于播放时间的时间点，对应time属性
   * createUid: 创建于基于播放时间点的uid时间戳属性，对应uniqueID
   * destroyUid: 销毁于基于播放时间点的uid时间戳属性，对应uniqueID
   * type: 该容器是文档类型还是白板类型
   *
   * 因为可以多次创建同一cid的容器，所以，前一个cid 的生命周期终止于第二个同cid的创建时间点
   * @member Vod
   * @returns {[{cid, create, destroy, createUid, destroyUid:, type}]|Array}
   */
  allCidInfos() {
    // 遍历数据获取info
    return this._allCid;
  }

  allActivatedCids() {
    return this._allActivatedCids;
  }

  allWatchStatus() {
    return this._allWatchStatus;
  }

  get data() {
    return this._data;
  }

  get dbController() {
    return this._controller;
  }

  static get defaultDBOption() {
    return {
      name: 'DocModuleDB',
      stores: [
        {
          name: VHALL_DOC_VOD_STORE,
          indexes: [
            { name: 'uid' },
            { name: 'time' },
            { name: 'flipOver' },
            { name: 'cid' },
            { name: 'hash' },
            { name: 'currentPage' }
          ],
          autoIncrement: true
        }
      ],
      use: VHALL_DOC_VOD_STORE
    };
  }

  _outputQueryResult(result, time, start, end) {
    // 测试输出查询结果
    if (result.length > 0) {
      let r = '';
      result.forEach(res => {
        r += ` createAt:${res.time}--- uniqueID:${res.uid};`;
      });
      log.info(` time: ${time.toFixed(1)}, count: ${result.length}, result: ${r}, queryString: [${start}-${end}]`);
    } else {
      log.debug(time.toFixed(1));
    }
  }
}
